"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialFileHistory = exports.initialHistory = exports.initialCheckingFiles = void 0;
exports.initialCheckingFiles = {
    status: 'STANDBY',
    files: []
};
exports.initialHistory = { hardDeleted: {}, deleted: {}, colored: {} };
exports.initialFileHistory = {
    history: [exports.initialHistory],
    changes: [],
    currentFrame: exports.initialHistory,
    selectedFiles: [],
    historyBrowsed: 0,
    enableRedo: false,
    enableRestore: false
};
//# sourceMappingURL=types.js.map